/**
 * script_search-tab.js
 * タブUIの初期化と操作（WAI-ARIA Tabs パターン準拠）
 */

/**
 * 1つの [data-tabs] コンテナ内のタブUIを初期化する
 * @param {Element} container - [data-tabs] 属性を持つ要素
 */
function initTabs(container) {
  // 二重初期化を防ぐ：すでに初期化済みならスキップ
  if (container.dataset.tabsInit === "true") return;
  container.dataset.tabsInit = "true";

  const tabs = Array.from(container.querySelectorAll('[role="tab"]'));
  const panels = Array.from(container.querySelectorAll('[role="tabpanel"]'));

  /**
   * 指定されたタブをアクティブにし、対応するパネルを表示する
   * @param {Element} targetTab - アクティブにするタブボタン
   * @param {boolean} moveFocus - フォーカスをタブに移動するか（キーボード操作時は true）
   */
  function activateTab(targetTab, moveFocus = true) {
    // すべてのタブを非選択状態にし、Tabキーのフォーカス順から外す
    tabs.forEach((tab) => {
      tab.setAttribute("aria-selected", "false");
      tab.setAttribute("tabindex", "-1");
    });

    // すべてのパネルを非表示にする
    panels.forEach((panel) => {
      panel.hidden = true;
    });

    // 対象タブを選択状態にし、Tabキーで到達できるようにする
    targetTab.setAttribute("aria-selected", "true");
    targetTab.setAttribute("tabindex", "0");
    if (moveFocus) targetTab.focus();

    // aria-controls 属性からパネルIDを取得し、対応するパネルを表示する
    const panelId = targetTab.getAttribute("aria-controls");
    const targetPanel = container.querySelector(`#${CSS.escape(panelId)}`);
    if (targetPanel) {
      targetPanel.hidden = false;
    }
  }

  tabs.forEach((tab, index) => {
    // クリックでタブを切り替える
    tab.addEventListener("click", () => {
      activateTab(tab);
    });

    // キーボード操作でタブ間を移動する（WAI-ARIA Tabs キーボードインタラクション）
    tab.addEventListener("keydown", (e) => {
      let newIndex = null;

      switch (e.key) {
        case "ArrowRight":
          // 次のタブへ（最後のタブなら最初に戻る）
          newIndex = (index + 1) % tabs.length;
          break;
        case "ArrowLeft":
          // 前のタブへ（最初のタブなら最後に戻る）
          newIndex = (index - 1 + tabs.length) % tabs.length;
          break;
        case "Home":
          // 最初のタブへジャンプ
          newIndex = 0;
          break;
        case "End":
          // 最後のタブへジャンプ
          newIndex = tabs.length - 1;
          break;
        default:
          return;
      }

      e.preventDefault();
      activateTab(tabs[newIndex]);
    });
  });
}

/**
 * 指定された起点要素内のすべての [data-tabs] コンテナを初期化する
 * @param {Document|Element} root - 検索の起点（通常は document 全体）
 */
function initAllTabs(root) {
  root.querySelectorAll("[data-tabs]").forEach(initTabs);
}

// ページ読み込み時：DOM構築完了後にすべてのタブを初期化する
document.addEventListener("DOMContentLoaded", () => {
  initAllTabs(document);
});

// テーマエディタ：セクションが追加・再読み込みされたときに再初期化する
// （再描画されたセクション内だけを対象にすることで、他セクションに影響しない）
document.addEventListener("shopify:section:load", (e) => {
  initAllTabs(e.target);
});
